import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Paper } from '@mui/material';
import { CheckCircle2, XCircle } from 'lucide-react';
import apiClient from './utils/apiClient';

const EmailVerification = () => {
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('Verifying your email...');
  const navigate = useNavigate();
  const { verificationToken } = useParams();
  const isFetching = useRef(false); // Ref to track if the API call is already in progress

  useEffect(() => {
    const verifyEmail = async () => {
      if (isFetching.current) return; // Prevent duplicate API calls
      isFetching.current = true;

      try {
        if (!verificationToken) {
          setStatus('error');
          setMessage('Invalid verification link');
          return;
        }

        await apiClient.get(`/verify/${verificationToken}`);
        setStatus('success');
        setMessage('Your email has been verified successfully! You can now login to your account.');
      } catch (error) {
        setStatus('error');
        setMessage('Failed to verify your email. The link may be expired or invalid.');
      }
    };

    verifyEmail();
  }, [verificationToken, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Box sx={{ mb: 3 }}>
            {status === 'loading' && <CircularProgress size={48} />}
            {status === 'success' && <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto" />}
            {status === 'error' && <XCircle className="w-12 h-12 text-red-500 mx-auto" />}
          </Box>

          <Typography variant="h5" gutterBottom>
            Email Verification
          </Typography>

          <Typography
            variant="body1"
            color={status === 'error' ? 'error' : 'text.secondary'}
            sx={{ mt: 2 }}
          >
            {message}
          </Typography>

          {status === 'success' && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              <span> <a href="/login" style={{ color: '#1976d2', textDecoration: 'underline' }}>Login</a></span>
          </Typography>
          )}
        </Paper>
      </div>
    </div>
  );
};

export default EmailVerification;
